
import { Component, Vue } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import uploadTracking from '../components/UploadtrackingDialog.vue'
import { OderService, OrderDto,UpdateOrderDto ,TrackInput} from "@/api/service-proxies";
import { orderRecordService } from '@/api/payments/order-record';
@Component({
  name: "orderDetails",
  components: {
     uploadTracking
  }
})
export default class orderDetails extends Vue {
    minutes :any= 0; //倒计时分钟
		seconds:any= 0; //倒计时秒
		isEnd= false //支付超时
    active = 2
    reverse=true
    oderService = new OderService();
    countdownInterval:any=null
    order: UpdateOrderDto = new UpdateOrderDto();
    activities:any= []
    img = 'http://file6.wkxiaolvsan.com/files/2~SCeMd~bFag1oXjQyxXsawLD13azAALgIwAC-EmwzXNfiUxxzieD9NWI3Gf6-d7rtQ'

    back() {
    this.$router.back();
  }

  mounted() {

this.getOrder(this.$route.params["id"]);
this.int();
}
int(){
    if(this.order.companyNumber!=null){
    var item = new TrackInput();
    item.companyCode = this.order.companyCode;
    item.companyNumber = this.order.companyNumber;
    this.oderService.queryTrack(item).then(res=>{
    var json=JSON.parse(res);
    this.activities =json.data;
  });
}
}
timeLeft() {

    }

  updateTracking(row) {
    (this.$refs.uploadTrackingRef as uploadTracking).open(row)
  }

  async getOrder(id:string ) {
        let order = await this.oderService.get(id);
        this.order = <UpdateOrderDto>order;
            this.countDown();
    }

    // 倒计时
    countDown(){
        const now = new Date();
      const timeToCompare = new Date(this.order.creationTime.valueOf());
      // 计算时间差，如果超过一个小时（60分钟 * 60秒 * 1000毫秒），则返回true
       if(now.getTime() - timeToCompare.getTime()<0){
        return;
       }

        	// 当前时间
            let nowTime:any = new Date()
            // 获取创建订单15分钟后的时间,this.payForm.create_time:订单创建时间
            let endTime:any = new Date(this.order.creationTime.valueOf());
            endTime.setMinutes(endTime.getMinutes() + 60) // 结束时间，获取创建订单15分钟后的时间
            // 两个日期相差的时间戳，以毫秒为单位（1000ms = 1s）
            let totalTime = endTime - nowTime
            // 结束时间大于现在的时间
            if(totalTime>0){
                let timer = setInterval(() => {
                    if (totalTime >= 0) {
                        //获取分钟数
                        let minutes =
                            Math.floor((((totalTime % (3600 * 24 * 1000)) / 1000) % 3600) / 60);
                        //获取秒数
                        let seconds =
                            Math.floor((((totalTime % (3600 * 24 * 1000)) / 1000) % 3600) % 60).toString().padStart(2, "0");;
                        this.minutes = minutes
                        this.seconds = seconds
                        totalTime -= 1000;
                        // console.log(totalTime)
                    } else {
                        clearInterval(timer); // 停止调用函数
                        this.isEnd = true
                    }
                }, 1000);
            }else{
                this.isEnd = true
            }
        }
}
